import { ref } from '@vue/composition-api'
import qs from 'qs' //why qs? https://github.com/axios/axios#using-applicationx-www-form-urlencoded-format
import axios from 'axios'
import useAlerts from '../../shared/composables/useAlerts'
import useCheckout from '../composables/useCheckout'

//make this state variable global
let editingAddress
let loadingAddressForm
let customerAddresses
let loadingAddresses
let invalidAddress

// let quoteParams;

export default function useCheckoutAddresses() {
  const { addAlert } = useAlerts()

  if (editingAddress == undefined) {
    editingAddress = ref(false)
  }

  if (loadingAddressForm == undefined) {
    loadingAddressForm = ref(false)
  }

  if (customerAddresses == undefined) {
    customerAddresses = ref([])
  }

  if (loadingAddresses == undefined) {
    loadingAddresses = ref(false)
  }

  if (invalidAddress == undefined) {
    invalidAddress = ref(false)
  }
  const { addresses } = useCheckout()

  const getCustAddresses = (
    contactId,
    custId = '',
    type = 'shipping',
    filterCol = '',
    filterVal = ''
  ) => {
    loadingAddresses.value = true
    return new Promise(function(resolve) {
      if (customerAddresses.value.length == 0) {
        const params = qs.stringify({
          ctctNo: contactId,
          custNo: custId,
          type,
          filterCol,
          filterVal,
        })

        axios
          .post('actions/checkout.cfc?method=getCustAddresses', params)
          .then(function(response) {
            customerAddresses.value = response.data
            loadingAddresses.value = false
            resolve()
          })
          .catch((error) => {
            loadingAddresses.value = false
            addAlert('An error occurred loading addresses.', 'alert-danger', 7000)
            console.log(error)
          })
      } else {
        loadingAddresses.value = false
        resolve()
      }
    })
  }

  const selectAddress = (option, type) => {
    const { clearTaxAndShipping } = useCheckout()

    if (!option.ATTNNAME && !option.ATTNPHONE) {
      let oldAddress = { ...addresses.value[type] }
      option.ATTNNAME = oldAddress.ATTNNAME
      option.ATTNPHONE = oldAddress.ATTNPHONE
    }
    option.VALID = addressErrors(option).length == 0
    addresses.value[type] = option
    editingAddress.value = false
    //Shipping data can alter tax and is based on address so we must clear if we change the shipping address.
    if (type == 'shipping') {
      clearTaxAndShipping()
      window.sureTax = null
      window.newAddresses = null
    }
  }

  const saveAddress = (addr, lines, type) => {
    const newAddress = {
      address1: lines.address1,
      address2: lines.address2,
      address3: lines.address3,
      address4: lines.address4,
      state: addr.STATE,
    }
    window.newAddresses = newAddress
    // console.log(JSON.stringify(addr) + " THIS IS THE ADDRESS before*******************************");

    addr.ADDRESS =
      lines.address1 + '\r\n' + lines.address2 + '\r\n' + lines.address3 + '\r\n' + lines.address4
    addr.VALID = addressErrors(addr).length == 0
    addr.ID = 100000000000000020000 //Is there another way to identify a "new" address?

    if (addr.VALID) {
      editingAddress.value = false
    }
    addresses.value[type] = addr
    if (type == 'shipping') {
      //remove any other new addresses that may have been added (only keep one new address at a time)
      for (var i = customerAddresses.value.length - 1; i >= 0; --i) {
        if (customerAddresses.value[i].ID == 100000000000000020000) {
          customerAddresses.value.splice(i, 1)
        }
      }
      //add address to beginning of array
      customerAddresses.value.unshift(addr)
    }
  }

  const breakApartAddress = (combinedAddress) => {
    var addrLinesArr = combinedAddress.match(/[^\r\n]+/g) || []
    var lines = {}

    for (let i = 0; i <= 3; i++) {
      let aItem = 'address' + (i + 2)
      lines[aItem] = addrLinesArr.length - 1 >= i ? addrLinesArr[i] : ''
    }

    return lines
  }

  const addressErrors = (address) => {
    var e = []
    if (address.ADDRESS == '') {
      e.push('address')
    }
    if (address.CITY == '') {
      e.push('city')
    }
    if (address.COUNTRY == '' || address.COUNTRY == 0) {
      e.push('country')
    }
    if (address.STATE == '') {
      e.push('state')
    }
    if (address.POSTAL == '') {
      e.push('postal')
    }
    window.sureTax = {}

    // console.log(JSON.stringify(address) + "THIS IS THE ADDRESS*******************************");

    if (window.newAddresses) {
      address.ADDRESS = window.newAddresses.address2
      address.STATE_ABBR = window.newAddresses.state
      // console.log(address.STATE_ABBR + " THIS IS THE STATE*******************************");
    }

    const paramsAdd = new URLSearchParams(
      qs.stringify({
        primaryAddressLine: address.ADDRESS,
        city: address.CITY,
        state: address.STATE_ABBR,
        zipCode: address.POSTAL,
        country: address.COUNTRY,
      })
    )

    window.enteredAddress = address
    axios
      .post('/actions/suretax.cfc?method=validateAddress', paramsAdd)
      .then((response) => {
        const validatedAddress = response.data
        // console.log(JSON.stringify(response) + ' RESPONSE FOR VALIDATEADDRESS')
        switch (validatedAddress.ReturnCode) {
          case 1:
            alert('Invalid request message format')
            e.push('Invalid request message format')
            break
          case 2:
            alert('Invalid validation key')
            e.push('Invalid validation key')
            break
          case 3:
            alert('Input Address is not found. Please check the address and try again.')
            e.push('Input Address is not found. Please check the address and try again.')
            invalidAddress.value = true
            validatedAddress.value = {
              BusinessUnit: '',
              City: null,
              ClientNumber: '000004385',
              ClientTracking: 'Test',
              County: null,
              DayLightSaving: false,
              FirmName: null,
              GeoCode: null,
              IsMatchLimitExceed: false,
              Latitude: 0,
              Longitude: 0,
              Message: 'Address not found',
              PrimaryAddressLine: address.ADDRESS,
              ResultList: [],
              ReturnCode: 3,
              Score: 0,
              SecondaryAddressLine: null,
              State: address.STATE_ABBR,
              TimeZone: 0,
              TopMatchUnique: false,
              ZIPCode: address.POSTAL,
              ZIPPlus4: null,
            }
            window.sureTax = {
              validatedAddress: validatedAddress,
            }

            break
          case 100:
            window.sureTax = {
              validatedAddress: validatedAddress,
            }
            invalidAddress.value = false
            // console.log('Input Address is not found', invalidAddress.value)
            break
          case 999:
            alert('Application error')
            e.push('Application error')
            break
          default:
            console.log(`Unknown ReturnCode: ${validatedAddress.ReturnCode}`)
            e.push('Unknown ReturnCode' + validatedAddress.ReturnCode)
        }
      })
      .catch((error) => {
        console.error(error + ' ERROR FOR VALIDATEADDRESS')
      })

    return e
  }

  const newAddress = (type) => {
    let oldAddress = { ...addresses.value[type] }

    addresses.value[type] = {
      ID: 'new',
      ORGANIZATION: '',
      ADDRESS: '',
      CITY: '',
      STATE: '',
      POSTAL: '',
      COUNTRY: '',
      SEQUENCE: '',
      ATTNNAME: oldAddress.ATTNNAME,
      ATTNPHONE: oldAddress.ATTNPHONE,
      VALID: false,
      NEWADDRESS: true,
    }
  }

  const revertToDefaultAddress = (type) => {
    if (customerAddresses.value.length) {
      let oldAddress = { ...addresses.value[type] }
      let newAddress = customerAddresses.value[0]
      newAddress.ATTNNAME = oldAddress.ATTNNAME
      newAddress.ATTNPHONE = oldAddress.ATTNPHONE
      selectAddress(newAddress, type)
    }
  }

  return {
    editingAddress,
    loadingAddressForm,
    customerAddresses,
    getCustAddresses,
    selectAddress,
    breakApartAddress,
    saveAddress,
    addressErrors,
    newAddress,
    revertToDefaultAddress,
    loadingAddresses,
    invalidAddress,
  }
}
